import PricingSpread from './PricingSpread';

export default PricingSpread;
